import React, { useState } from "react";
import { Card, Button, Collapse } from "react-bootstrap";
import {
  FaArrowAltCircleDown,
  FaArrowAltCircleRight,
  FaArrowRight,
  FaRegFolderOpen,
  FaBook,
} from "react-icons/fa";
import "./AccordionItem.css";
import { FaEyeSlash } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { Boxes } from "lucide-react";
import ModuleProgression from "../ModuleProgression/ModuleProgression";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const AccordionItem = (props) => {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [open, setOpen] = useState(false);
  const [mouseOnModule, setMouseOnModule] = useState(false);
  const navigate = useNavigate();

  let textSizeClass = "";
  let titleStyle = "";
  if (props.isLesson) {
    textSizeClass = "fs-7";
    titleStyle = "text-module";
  } else if (props.isSection) {
    textSizeClass = "fs-6";
  } else {
    textSizeClass = "fs-4";
    titleStyle = "text-module";
  }

  const handleNavigate = () => {
    if (props.isLesson === true) {
      navigate(
        `/programs/${props.program_id}/module/${props.moduleId}/${props.lessonId}`,
        {
          state: {
            comeFromSection: props.sectionId,
            selectedLesson: props.lessonId,
          },
        }
      );
    } else if (!props.isSection || props.isSection === false) {
      navigate(`/programs/${props.program_id}/module/${props._id}`);
    }
  };

  return (
    <Card className="mb-2 border-1 rounded-3 shadow">
      <Card.Header className="d-flex align-items-center bg-light p-3">
        {props.isLesson === false || !props.isLesson ? (
          <Button
            className="text-dark fs-5 button-accordion"
            variant="link"
            onClick={() => {
              setOpen(!open);
            }}
          >
            {open ? (
              <FaArrowAltCircleDown className="me-4" />
            ) : (
              <FaArrowAltCircleRight className="me-4" />
            )}{" "}
          </Button>
        ) : null}
        {!props.isSection && !props.isLesson ? (
          <div className="me-4">
            <ModuleProgression progress={props.progress} />
          </div>
        ) : null}
        {props.isSection === true ? (
          <FaRegFolderOpen className="me-4" size={30} strokeWidth={1} />
        ) : null}
        {props.isLesson === true ? <FaBook className="me-4" size={20} /> : null}

        <div className="flex-grow-1">
          <h6
            onClick={handleNavigate}
            onMouseOver={() => setMouseOnModule(true)}
            onMouseOut={() => setMouseOnModule(false)}
            className={`mb-0 fw-bold ${titleStyle} ${textSizeClass}`}
          >
            {props.title}{" "}
            {mouseOnModule && !props.isSection ? (
              <FaArrowRight className="ms-2" />
            ) : null}
          </h6>
          <h8 className="text-muted">{props.description}</h8>
        </div>
        {props.is_visible === false && <FaEyeSlash size={30} />}
      </Card.Header>
      {!props.isLesson ? (
        <Collapse in={open}>
          <Card.Body className="border-top">{props.children}</Card.Body>
        </Collapse>
      ) : null}
    </Card>
  );
};

export default AccordionItem;
